module.exports = __webpack_public_path__ + "static/media/stadium_4.f8ac934d.jpg";